import { OptionProps } from 'src/components/ButtonDropdown';

export const SEARCH_GROUPS: OptionProps[] = [
  { label: 'By Episode', value: 'episode' },
  { label: 'By Show', value: 'show' },
];

export const SHOW_ONLY_SEARCH_GROUPS: OptionProps[] = [
  { label: 'By Show', value: 'show' },
];
